module.exports = __webpack_public_path__ + "img/1193115628.9ad31d25.jpg";